export default __webpack_public_path__ + "static/media/hour-glass.139334cb.svg";